<template>
  <div class="update-avatar">
    <div class="header">
      <TopBar :title ="$t('updateAvatar.tittle')"></TopBar>
    </div>
    <div class="content">
      <div class="avatar">
        <van-image
          round
          width="3rem"
          height="3rem"
          :src="avatar"
          />
      </div>
    </div>
    <div class="btn" style="margin: 16px;">
      <van-uploader :max-count="1" :before-read="beforeRead" :after-read="afterRead">
        <van-button style="background: #4E91C4;border:1px solid #4E91C4" round block type="info" @click="choose">{{ $t('updateAvatar.chooseImg') }}</van-button>
      </van-uploader>
      <br>
      <br>
      <van-button style="background: #FBC260;border:1px solid #FBC260" round block type="warning" @click="submit">{{ $t('updateAvatar.save') }}</van-button>
    </div>
  </div>
</template>

<script>
  import { Toast } from 'vant';
  import { avatarUrl, accountsAvatar,accounts} from '@/api/api.js';
  import { Notify } from 'vant';
  import TopBar from '@/common/top-bar/index.vue'

  export default {
    name: 'UpdateAvatar',
    components: {
      TopBar
    },
    data () {
      return {
        avatar:"",
        avatarUrl:"",
      }
    },
    methods: {
      beforeRead(file) {
        if (!file.type.startsWith('image/')) {
          Toast('请上传图片');
          return false;
        }
        return true;
      },
      afterRead(file){
        this.avatar= file.content;
        const params = {
          source:this.avatar,
        }
        avatarUrl(params).then(res=>{
          if (res.code === 200) {
            this.avatarUrl = res.data.avatarUrl;
            Notify({ type: 'success', message: res.errors[0] });
          }else{
            Notify({ type: 'danger', message: res.errors[0] });
          }
        })
      },
      choose(){},
      async submit(){
        const loginInfo = JSON.parse(localStorage.getItem('LOGIN_INFO'));
        const params = {
          id:loginInfo.id,
          avatarUrl:this.avatarUrl
        }
        await accountsAvatar(params).then(res=>{
          if (res.code === 200) {
            this.updateUserInfo(loginInfo.id);
            Notify({ type: 'success', message: res.errors[0] });
          }else{
            Notify({ type: 'danger', message: res.errors[0] });
          }
        })
      },
      updateUserInfo(userId){
        const params = {
            id: userId
          }
          accounts(params).then(res=>{
            if (res.code === 200) {
              res.data.avatarUrl = res.data.avatarUrl + '?v='+ Date.now();
              this.$store.commit('setAccountInfo',res.data);
            }
          })
      }

    },
    mounted () {
      this.avatar = this.$store.state.loginInfo.avatarUrl;
    },
    activated () {
    }
  }
</script>

<style lang="stylus" scoped>
  /deep/.update-avatar{
    .content{
      display: flex;
      justify-content:center;
      margin: .3rem 0px;
      .avatar{
      }
    }
    .btn{
      button{
        font-size: 22px;
      }
      .van-uploader{
        width: 100% !important;
        .van-uploader__input-wrapper{
          width: 100%;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/updateAvatar/UpdateAvatar.vue